import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const createNotificationFromPresets = async (domain: string, flowId: number, presetIds: number[]): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `flows/${flowId}/messages-templates-from-presets`,
        method: 'POST',
        params: { presetIds },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}